/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the hatsAppApiConfiguration configuration object with a given root URL.
 */
export function providehatsAppApiConfiguration(rootUrl: string) {
  var config = new hatsAppApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: hatsAppApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class hatsAppApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `WhatsAppModule.forRoot()`
 */
export interface hatsAppApiConfigurationParams {
  rootUrl?: string;
}
